export default {
  cities: [],
  currentCity: '',
  dataPageCities: [],
  ctxButtons: null,
  pageAbout: [],
  videoIsPlaying: false,
  userStopAudio: false,
};



// WEBPACK FOOTER //
// ./src/store/state.js